import React from 'react';

export const AddressIcon = (props: JSX.IntrinsicElements['svg']) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="32" viewBox="0 0 24 32" {...props}>
        <path
            fill="currentColor"
            d="M11.657 30.39a2.236 2.236 0 01-1.838-.956L2.129 18.37l-.114-.169-.083-.123a1.064 1.064 0 01-.07-.08A11.652 11.652 0 019.201.266a11.651 11.651 0 0112.236 17.732l-.054.085-.044.06-.165.227-.027.035-7.67 11.026a2.236 2.236 0 01-1.83.959h.009zM3.54 16.79l.024.03.141.21.127.182 7.674 11.026a.168.168 0 00.233.041.273.273 0 00.042-.041l7.712-11.085a6.64 6.64 0 01.192-.26l.027-.044A9.59 9.59 0 009.636 2.284 9.589 9.589 0 003.54 16.79zm8.11.322a5.459 5.459 0 115.462-5.447 5.464 5.464 0 01-5.461 5.447zm0-8.852a3.393 3.393 0 10.007 6.786 3.393 3.393 0 00-.006-6.786z"
        />
    </svg>
);
